import { render, staticRenderFns } from "./spinningWheel.vue?vue&type=template&id=86992f9e&scoped=true"
import script from "./spinningWheel.vue?vue&type=script&lang=js"
export * from "./spinningWheel.vue?vue&type=script&lang=js"
import style0 from "./spinningWheel.vue?vue&type=style&index=0&id=86992f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86992f9e",
  null
  
)

export default component.exports